var __default__ = {root:'m_87cf2631'};
export default __default__;